import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { Visitor } from "./Visitor.model";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { Employee } from "./Employee.model";
import { AccessCard } from "./AccessCard.model";
import { Face } from "./Face.model";
import { Feedback } from "./Feedback.model";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { RegexType } from "../../services/RegexPatternLibrary";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Visit'
})
export class Visit extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn, IPropretyAttribute.DateRangeFilterColumn] })
  startDate!: Date | undefined;

  // Pas de DateRangeFilterColumn : la plage de dates ne porte que sur la date de debut,
  // seule propriete que le composant de liste retient.
  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  endDate?: Date;

  @Validation({ maxLength: 255, propertyType: RegexType.Alphanumeric, minLength: 2, })
  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  company?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn] })
  status!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  //@Validation({ maxLength: 255, propertyType: RegexType.Numeric, minLength: 1, })
  visitId!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  numberOfNotificationSent!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_Visitor!: number;

  fK_Image_Badge?: number;

  fK_Image_Photo?: number;

  fK_Image_Signature?: number;

  fK_Image_QRCode?: number;

  fK_Employee?: number;

  employeeName?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  visitorType!: number;

  fK_Image_Agreements?: number;

  fK_Image_Engagement?: number;

  fK_Image_SignatureEngagement?: number;

  fK_Image_Covid?: number;

  engagementDate?: Date;

  fK_AccessCard?: number;

  symptoms?: boolean;

  fK_Face?: number;

  fK_Image_Quiz?: number;

  quizStatus?: number;

  fK_Employee_Origin?: number;

  quizDate?: Date;

  agreementsDate?: Date;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Visitor })
  visitor?: Visitor;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageBadge?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imagePhoto?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageSignature?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageQRCode?: FSTREAM_Image;

  @NestedProperty({ TargetType: Employee })
  employee?: Employee;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageAgreements?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageEngagement?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageSignatureEngagement?: FSTREAM_Image;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageCovid?: FSTREAM_Image;

  @NavigationProperty({ TargetType: AccessCard })
  accessCards?: AccessCard[];

  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  attachedCards!: string;

  @NestedProperty({ TargetType: Face })
  face?: Face;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageQuiz?: FSTREAM_Image;

  @NestedProperty({ TargetType: Employee })
  employeeOrigin?: Employee;

  @NavigationProperty({ TargetType: Feedback })
  feedbacks?: Feedback[];


  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];


  // propriétés non mappées 
  isGroupedVisit: boolean = false;      // toutes le vistes de groupe = true
  isGroupInitiator: boolean = false;    // Dans une visite groupée, mettre a true uniquement sur le premier de la liste 
  groupVisitors!: string;              // Tous les noms (full-names) des visiteurs 



  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Employee?: string[];
  photoFile?: File;
  signatureFile?: File;
  previousVisit?: Visit;
  fK_PolicyRdlc?: number;
  fK_PolicyPdf?: number;
  allEngamgementChecked?: boolean = false;
  allCovidChecked?: boolean = false;

  quizAnswers?: { quizId: number; selectedResponseId: number; isCorrect: boolean }[];

  GetType(): IEntityMetaData {
    return Visit.getMetaData();
  }
}
